export const exportName = {
    Assets: "Assets",
    FundSeries: "FundSeries",
    Managers: "Managers",
    PacingPlans: "PacingPlans",
    Portfolios: "Portfolios",
    Research: "Research"
};
